<template>
    <div id="colorSet">
        <div class="colorSet container">
            <h4>颜色管理</h4>
            <ul class="clearfix">
                <li v-for="(item,index) in ColorLists" :key="index" class="ColorListPart listPart">
                    <span  style="color: #333;padding:3px;">{{item.colorName}}</span>
                    <span class="colorHint" :style="{background: item.colorNumber}"></span>
                    <span class="exitBtn" @click.stop="exitColor(item,index)" v-if="colorAuth.exitColor">编辑</span>
                    <i class="el-icon-error activeDelBtn" @click.stop="deleColor(item)" v-if="colorAuth.deleColor"></i>
                </li>
                <li class="addContent" @click="newColor()" v-if="colorAuth.newColor"><i class="el-icon-plus"></i></li>
            </ul>
            <el-dialog :title="textMenu[dialogMenuStatus]" :visible.sync="dislogColor" :close-on-click-modal="false" width="600px"  @close="emptyDialog('ColorForm')">
                <el-form ref="ColorForm" :model="ColorForm" label-width="100px" :label-position="labelPosition" :rules="ColorFormRules">
                    <el-form-item label="颜色名称：" prop="colorName">
                        <el-input clearable v-model.trim="ColorForm.colorName" maxlength="12" placeholder="请输入颜色名称(不超过12个字)"></el-input>
                    </el-form-item>
                    <el-form-item label="颜色色号：" prop="colorNumber">
                        <el-input clearable v-model.trim="ColorForm.colorNumber" placeholder="请准确填写颜色RGB" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-color-picker v-model="ColorForm.colorNumber"></el-color-picker>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer" >
                    <el-button v-if="dialogMenuStatus!=='update'" type="success" @click="addEventFormSubmitBtn('ColorForm')">添加</el-button>
                    <el-button v-else type="success" @click="saveEventFormSubmitBtn('ColorForm')">保存</el-button> 
                    <el-button @click="emptyDialog('ColorForm')">取 消</el-button> 
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import {getPermission} from '../../api/authRequest'
    import {insertColor,selectAll,updateColor,deleteColor} from "../../api/api";
    export default {
        name: 'colorSet',
        data() {
            return {
                labelPosition:'left',
                dislogColor:false,
                dialogMenuStatus: "",
                textMenu: {
                    update: "修改颜色",
                    create: "新增颜色"
                },
                ColorForm:{
                    colorName: '',
                    colorNumber: '',
                },
                ColorFormRules:{//validateRoleName
                    colorName: [{ required: true, message: "请输入颜色名称", trigger: "blur" }],
                    colorNumber: [{ required: true, message: "请选择色号", trigger: 'submit' }],
                },
                ColorLists:[],
                colorAuth:{
                    newColor:false,
                    exitColor:false,
                    deleColor:false,
                }
            }
        },
        mounted () {
            this.getColorList();
            this.colorAuth.newColor= getPermission('/api/basicSetting/color/insertColor');
            this.colorAuth.exitColor= getPermission('/api/basicSetting/color/updateColor');
            this.colorAuth.deleColor= getPermission('/api/basicSetting/color/deleteColor');
        },
        methods: {
            //获取颜色列表
            getColorList() {
                let para={
                    colorName: this.ColorForm.colorName,
                    colorNumber: this.ColorForm.colorNumber,
                }
                selectAll().then(res => {
                    if (res.data.status==100) {
                        this.ColorLists = res.data.results
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //清空dialog
            emptyDialog(formName) {
                this.$refs[formName].resetFields();
                this.dislogColor = false
            },
            //新增颜色
            newColor() {
                this.ColorForm = {
                    colorName: '',
                    colorNumber: '',
                },
                this.dislogColor = true
                this.dialogMenuStatus = "create";
            },
            //确定新增颜色
            addEventFormSubmitBtn(formname){
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        // console.log('验证成功')
                        // console.log(this.ColorForm)
                        // 获取当前input上输入的文字
                        let para={
                            colorName: this.ColorForm.colorName,
                            colorNumber: this.ColorForm.colorNumber,
                        }
                        insertColor(para).then(res => {
                            if (res.data.status==100) {
                                this.$message({
                                    message: res.data.message,
                                    type: "success"
                                });
                                /*关闭弹窗，重置输入框*/
                                this.dislogColor = false;
                                this.$refs[formname].resetFields();
                                /*刷新颜色列表*/
                                this.getColorList();

                            }else{
                                this.$message({
                                    message: res.data.message,
                                    type: "error"
                                });
                                // console.log('没提交成功')
                                this.dislogColor = false;
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            },
            //编辑颜色
            exitColor(item,index) {
                this.dislogColor = true
                this.dialogMenuStatus = "update";
                this.ColorForm = Object.assign({}, item);
                // console.log(this.ColorForm)
            },
            //确定保存颜色
            saveEventFormSubmitBtn(formname){
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        // console.log('验证成功')
                        // console.log(this.ColorForm)
                        let para={
                            colorName: this.ColorForm.colorName,
                            colorNumber: this.ColorForm.colorNumber,
                            colorId:this.ColorForm.colorId
                        }
                        updateColor(para).then(res => {
                            if (res.data.status==100) {
                                this.$message({
                                    message: res.data.message,
                                    type: "success"
                                });
                                /*关闭弹窗，重置输入框*/
                                this.dislogColor = false;
                                this.$refs[formname].resetFields();
                                /*刷新颜色列表*/
                                this.getColorList();

                            }else{
                                this.$message({
                                    message: res.data.message,
                                    type: "error"
                                });
                                // console.log('没提交成功')
                                this.dislogColor = false;
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            },
            //删除颜色
            deleColor(item) {
                this.ColorForm = item
                // console.log(this.ColorForm)
                this.$confirm("确认删除该颜色?", "提示", {
                    type: "warning"
                }).then(() => {
                    // alert(row.autId)
                    const colorId = this.ColorForm.colorId
                    const colorData = {colorId:colorId}
                    deleteColor(colorData).then((res) => {
                        if (res.data.status == 100) {
                            this.$message({
                                message: res.data.message,
                                type: "success"
                            });
                            /*刷新颜色列表*/
                            this.getColorList();
                        }else{
                            this.$message({
                                message: res.data.message,
                                type: "error"
                            });
                        }
                    }).catch((error) => {
                        this.$Message.error(error.message);
                    })
                }).catch(() => {});
            }
        },
        computed: {
        },
        watch: {

        }
    }
</script>

<style lang="scss" type="text/css" scoped>
    #colorSet{
        .clearfix{
            clear:both;
            overflow: hidden;
        }
        .container{
            border-bottom: 1px dashed #c6c6c6;
            padding-bottom: 20px;
            h4{
                margin: 15px 0;
                font-weight: 500;
                font-size: 16px;
            }
            .listPart{
                width: 140px;
                float: left;
                border:1px solid #10c55b;
                margin:0 15px 10px 0;
                border-radius: 10px;
                height: 80px;
                line-height: 60px;
                text-align: center;
                position: relative;
                z-index: 0;
                cursor: pointer;
          /*& > span:first-child{display:none;}*/
                span.colorHint{
                   position: absolute;
                   right: 5px;
                   top: 5px;
                   display: block;
                   width: 20px;
                   height: 20px;
                   border-radius: 50%;
                   box-shadow: 0 0 5px 5px #f8f8f8;
                }
                span.active{
                    position: absolute;
                    top: -1px;
                    right:-1px;
                    display: block;
                    width: 30px;
                    height: 30px;
                    border-width: 16px;
                    border-style: solid;
                    border-color: #1abc9c #1abc9c #fff #fff;
                    border-top-right-radius:10px;
                }
                i{
                    position: absolute;
                    font-size: 14px;
                    color:#fff;
                    top: -9px;
                
                }
                span.exitBtn{
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    line-height: 20px;
                    left: 0;
                    border-top:1px solid #10c55b;
                    z-index:1;
                    display: block;
                    background-color: #d7ffe8;
                    border-radius: 0 0 10px 10px;
                    color:#10c55b;
                }
                i.activeDelBtn{
                    display: none;
                    position: absolute;
                    top: 5px;left: 5px;
                    color: #E03B5B;
                }
            }
            .listPart:hover{
                box-shadow: 3px 3px 3px #eee;
            }
            .listPart:hover i.activeDelBtn{
                display: block;
            }
            .addContent{
                border:1px dashed #c6c6c6;
                width: 50px;
                height: 50px;
                line-height: 50px;
                float: left;text-align: center;
                margin-top: 15px;cursor: pointer;
              i{
                  font-size: 20px;
              }
            }
    /*.bgShow{width: 20px;height: 20px;border-radius: 3px;display: block;}*/
        }
    }
</style>



// WEBPACK FOOTER //
// colorSet.vue?4cca04e2